import {
  LODGING_DOOR_TABLE_KEY,
  LODGING_TABLE_KEY,
} from 'constants/tableQueryKeys'
import { LodgingTable } from './LodgingTable/LodgingTable'
import { LodgingDoorTable } from '../LodgingDoors/LodgingDoorsTable/LodgingDoorsTable'
import { StandardSummaryResponse } from 'models/paginated-response'
import { useOpportunitiesContext } from 'pages/app/opportunities/opportunities-context'

export function LodgingChainDoorTable({
  pageParamName,
  setLodgingCount,
}: {
  pageParamName: string
  setLodgingCount: (count: StandardSummaryResponse) => void
}) {
  const { selectedTag } = useOpportunitiesContext()

  return (
    <>
      {selectedTag === 'fb-companies' ? (
        <LodgingTable
          pageParamName={`${pageParamName}-chain-page`}
          tableKey={LODGING_TABLE_KEY}
          setTotalRowsCount={setLodgingCount}
        />
      ) : null}

      {selectedTag === 'fb-locations' ? (
        <LodgingDoorTable
          pageParamName={`${pageParamName}-door-page`}
          tableKey={LODGING_DOOR_TABLE_KEY}
          setTotalRowsCount={(count) =>
            setLodgingCount({
              // Since they share the same component for showing doors and chains count
              // the value is swapped for the doors table, where the alt_count is the chains count
              count: count.alt_count,
              alt_count: count.count,
            })
          }
        />
      ) : null}
    </>
  )
}
